// extracted by mini-css-extract-plugin
export var aiStarIcon = "_81-4";
export var closeButton = "_81-6";
export var dismissButton = "_81-3";
export var editImageWithAiContainer = "_81-8";
export var imageUploadWrapper = "_81-7";
export var misspelledWord = "_81-5";
export var spellCheckContainer = "_81-2";
export var spin = "_81-1";
export var spinning = "_81-0";